/**
 * Resolve the name Forge renders for a CMMD project.
 *
 * A project has two names on purpose. `title` is the board name of record — the
 * portfolio row the CMMD Projects board shows, and the string every report and
 * agent write-back uses. `shortName` is what this app puts in the sidebar, the
 * breadcrumb, and thread lists, where a portfolio name is too long to scan.
 *
 * Both live on the CMMD project row, so the two names cannot drift the way a
 * client-local override would. This function is the one place the fallback is
 * applied; reading `shortName` directly at a call site is how half the surfaces
 * end up honouring it and half do not.
 *
 * Do NOT use this for identity. Repository-name derivation, the workspace↔project
 * name join, search indexing, and anything written back to CMMD must stay on
 * `title` — a display name that participated in a join would silently break it.
 */
export function projectDisplayName(
  project: { readonly title: string; readonly shortName?: string | null } | null | undefined,
): string | null {
  if (!project) return null;
  const short = project.shortName?.trim();
  return short !== undefined && short.length > 0 ? short : project.title;
}
